import React, { Component } from 'react';
import { HiPlus } from 'react-icons/hi';
import { MdClose } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

import { navigate_to_cart } from '../../../navigator/user/cart';
import { addToCart } from '../../services/services';
import ProductCard from '../blocks/ProductCard';

class AddToCartBtn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: null,
      addModalResult: false,
      pending: false,
    };
  }
  add_to_cart() {
    this.setState({ pending: true });

    addToCart(this.props.shopUid, this.props.product.id).then((items) => {
      if (items) {
        this.setState({
          product: items,
          addModalResult: true,
          pending: false,
        });
      } else {
        this.setState({ pending: false });
      }
    });
  }
  getProduct(product) {
    this.setState({ product: product });
  }
  render() {
    return (
      <div>
        {this.props.btnType === "product" && !this.props?.onlineOrdering ? (
          <div
            className="btn py-2 px-3 rounded28 bg-color-main text-white text-center fs-sm-7"
            onClick={this.props?.clickPhoneDetail}
          >
            تماس با فروشنده
          </div>
        ) : this.props.btnType !== "product" &&
          !this.props?.onlineOrdering ? null : this.props.btnType ===
            "product" && this.props?.onlineOrdering ? (
          <button
            style={{ width: "fit-content" }}
            className="btn py-2 px-3 rounded28 bg-color-main text-white text-center"
            onClick={() => this.add_to_cart()}
            disabled={this.state.pending}
          >
            {this.state.pending ? (
              <span className="spinner-border spinner-border-sm text-white align-middle" />
            ) : (
              <span className="fs-sm-7">افزودن به سبد خرید</span>
            )}
          </button>
        ) : (
          <button
            className="btn p-0"
            id={"product-" + this.props?.product?.id}
            onClick={() => this.add_to_cart()}
            disabled={this.state.pending}
          >
            <span
              className="rounded-circle border p-0 row mx-0 text-center"
              style={{ width: "35px", height: "35px" }}
            >
              <div className="col px-0 align-self-center">
                {this.state.pending ? (
                  <span className="spinner-border spinner-border-sm color-second align-middle" />
                ) : (
                  <HiPlus
                    className="col px-0 align-self-center color-second"
                    size="20"
                  />
                )}
              </div>
            </span>
          </button>
        )}
        {this.state.product && (
          <Modal
            dir="rtl"
            zIndex="9999999"
            className="m-0"
            contentClassName="border-0 position-fixed fixed-bottom rounded-0 w-auto"
            isOpen={this.state.addModalResult}
            toggle={() => this.setState({ addModalResult: false })}
          >
            <ModalBody className="p-0">
              <header className="row mx-0 p-3">
                <div className="col p-0">
                  <p className="mb-0 fs-5 fw-bolder">به سبد خرید اضافه شد</p>
                </div>
                <div className="col-auto p-0">
                  <MdClose
                    size="28"
                    onClick={() => this.setState({ addModalResult: false })}
                  />
                </div>
              </header>

              <ProductCard
                product={this.state.product.product}
                shopUid={this.state.product.product.shop.uid}
                quantity={this.state.product.quantity}
                quantityChanged={(product) => this.getProduct(product)}
              />
            </ModalBody>
            <ModalFooter className="border-top">
              <footer className="row mx-0 w-100">
                <div className="col p-0">
                  <Link to={navigate_to_cart()}>
                    <button className="btn rounded28 fs-6 px-3 py-2 bg-color-main text-white fw-bold">
                      دیدن سبد خرید
                    </button>
                  </Link>
                </div>
                <div className="col-auto text-start">
                  <p className="fs-7 text-muted mb-0">جمع کل</p>
                  {this.state.product.payable_price && (
                    <p className="fs-5 fw-bolder mb-0">
                      {this.state.product.payable_price.title}
                      <span className="fs-7 me-1">
                        {this.state.product.payable_price.currency}
                      </span>
                    </p>
                  )}
                </div>
              </footer>
            </ModalFooter>
          </Modal>
        )}
      </div>
    );
  }
}

export default AddToCartBtn;
